<template>
  <div class="wrap">
    <!--符号 start-->

    <div class="div1">|</div>
    <div class="div2"></div>

    <div class="div3"></div>
    <div class="div4"></div>
    <div class="div5"></div>
    <div class="div6"></div>
    <div class="div7"></div>

    <div class="div8"></div>
    <div class="div9"></div>
    <div class="div10"></div>
    <div class="div11"></div>
    <div class="div12"></div>

    <div class="div13"></div>
    <div class="div14"></div>

    <div class="div15"></div>
    <div class="div16"></div>

    <div class="div17"></div>
    <div class="div18"></div>

    <div class="div19"></div>
    <div class="div20"></div>

    <div class="div21"></div>
    <div class="div22"></div>

    <div class="div23">/</div>
    <div class="div24">/</div>
    <div class="div25">/</div>
    <div class="div26">/</div>
    <div class="div27">/</div>

    <div class="div28">1.2×</div>
    <div class="div29">+1.4×</div>
    <div class="div30">+3.3×</div>
    <div class="div31">+0.6×</div>
    <div class="div32">+0.999×</div>

    <!--符号   end-->

    <div class="node node-row-1">
      <p class="key">{{flowChart[12].indicator_name}}</p>
      <p class="value">{{flowChart[12].fact_value}}</p>
    </div>

    <!-- 二 -->
    <div class="node node-row-2-1">
      <p class="key">{{flowChart[7].indicator_name}}</p>
      <p class="value">{{flowChart[7].fact_value}}</p>
    </div>
    <div class="node node-row-2-2">
      <p class="key">{{flowChart[8].indicator_name}}</p>
      <p class="value">{{flowChart[8].fact_value}}</p>
    </div>
    <div class="node node-row-2-3">
      <p class="key">{{flowChart[9].indicator_name}}</p>
      <p class="value">{{flowChart[9].fact_value}}</p>
    </div>
    <div class="node node-row-2-4">
      
       <p class="key">{{flowChart[10].indicator_name}}</p>
      <p class="value">{{flowChart[10].fact_value}}</p>
    </div>
    <div class="node node-row-2-5">
     
      <p class="key">{{flowChart[11].indicator_name}}</p>
      <p class="value">{{flowChart[11].fact_value}}</p>
    </div>

    <!-- 3-->
    <div class="node node-row-3-1">
      <p class="key">{{flowChart[2].indicator_name}}(元)</p>
      <p class="value">{{flowChart[2].fact_value}}</p>
    </div>
    <div class="node node-row-3-2">
      <p class="key">{{flowChart[3].indicator_name}}(元)</p>
      <p class="value">{{flowChart[3].fact_value}}</p>
    </div>
    <div class="node node-row-3-3">
      <p class="key">{{flowChart[4].indicator_name}}(元)</p>
      <p class="value">{{flowChart[4].fact_value}}</p>
    </div>
    <div class="node node-row-3-4">
      <p class="key">{{flowChart[5].indicator_name}}(元)</p>
      <p class="value">{{flowChart[5].fact_value}}</p>
    </div>
    <div class="node node-row-3-5">
     <p class="key">{{flowChart[6].indicator_name}}(元)</p>
      <p class="value">{{flowChart[6].fact_value}}</p>
    </div>

    <!-- 4 -->

    <div class="node node-row-4-1">
       <p class="key">{{flowChart[0].indicator_name}}(元)</p>
      <p class="value">{{flowChart[0].fact_value}}</p>
    </div>
    <div class="node node-row-4-2">
      <p class="key">{{flowChart[0].indicator_name}}(元)</p>
      <p class="value">{{flowChart[0].fact_value}}</p>
    </div>
    <div class="node node-row-4-3">
      <p class="key">{{flowChart[0].indicator_name}}(元)</p>
      <p class="value">{{flowChart[0].fact_value}}</p>
    </div>
    <div class="node node-row-4-4">
      <p class="key">{{flowChart[1].indicator_name}}(元)</p>
      <p class="value">{{flowChart[1].fact_value}}</p>
    </div>
    <div class="node node-row-4-5">
      <p class="key">{{flowChart[0].indicator_name}}(元)</p>
      <p class="value">{{flowChart[0].fact_value}}</p>
    </div>
  </div>
</template>
<script>
export default {
  props: ["flowChart"],
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
<style scoped lang="less">
.wrap {
  width: 1330px;
  height: 500px;
  position: relative;
  color:#fff;
}

// 整体
.node {
  width: 146px;
  text-align: center;
  border-radius: 2px;
  border: 1px solid #bad2ed;
}
.key {
  font-size: 12px;
  height: 26px;
  line-height: 26px;
  background-color: #e5f0ff;
  position: relative;color:#000;
}
.value {
  border-top: 1px solid #bad2ed;
  height: 26px;
  line-height: 26px;
}

// 第一行
.node-row-1 {
  top: 20px;
  left: 600px;
  position: absolute;
}
// 线
.div1 {
  width: 10px;
  height: 10px;
  top: 71px;
  left: 673px;
  color: #bad2ed;
  font-weight: bolder;
  position: absolute;
}
.div2 {
  width: 855px;
  border-top: 1px solid #bad2ed;
  top: 85px;
  left: 250px;
  position: absolute;
}
.div3 {
  border-left: 1px solid #bad2ed;
  height: 14px;
  top: 85px;
  left: 250px;
  position: absolute;
}
.div4 {
  border-left: 1px solid #bad2ed;
  height: 14px;
  top: 85px;
  left: 462px;
  position: absolute;
}
.div5 {
  border-left: 1px solid #bad2ed;
  height: 14px;
  top: 85px;
  left: 674px;
  position: absolute;
}
.div6 {
  border-left: 1px solid #bad2ed;
  height: 14px;
  top: 85px;
  left: 891px;
  position: absolute;
}
.div7 {
  border-left: 1px solid #bad2ed;
  height: 14px;
  top: 85px;
  left: 1104px;
  position: absolute;
}
//  第二行
.node-row-2-1 {
  top: 99px;
  left: 175px;
  position: absolute;
}
.node-row-2-2 {
  top: 99px;
  left: 388px;
  position: absolute;
}
.node-row-2-3 {
  top: 99px;
  left: 600px;
  position: absolute;
}
.node-row-2-4 {
  top: 99px;
  left: 817px;
  position: absolute;
}
.node-row-2-5 {
  top: 99px;
  left: 1032px;
  position: absolute;
}
// 线
.div8 {
  border-left: 1px solid #bad2ed;
  height: 143px;
  top: 153px;
  left: 250px;
  position: absolute;
}
.div9 {
  border-left: 1px solid #bad2ed;
  height: 143px;
  top: 153px;
  left: 462px;
  position: absolute;
}
.div10 {
  border-left: 1px solid #bad2ed;
  height: 143px;
  top: 153px;
  left: 674px;
  position: absolute;
}
.div11 {
  border-left: 1px solid #bad2ed;
  height: 143px;
  top: 153px;
  left: 891px;
  position: absolute;
}
.div12 {
  border-left: 1px solid #bad2ed;
  height: 143px;
  top: 153px;
  left: 1104px;
  position: absolute;
}
.div13 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 224px;
  left: 242px;
  position: absolute;
}
.div14 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 295px;
  left: 242px;
  position: absolute;
}
.div15 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 224px;
  left: 454px;
  position: absolute;
}
.div16 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 295px;
  left: 454px;
  position: absolute;
}
.div17 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 224px;
  left: 666px;
  position: absolute;
}
.div18 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 295px;
  left: 666px;
  position: absolute;
}
.div19 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 224px;
  left: 883px;
  position: absolute;
}
.div20 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 295px;
  left: 883px;
  position: absolute;
}
.div21 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 224px;
  left: 1096px;
  position: absolute;
}
.div22 {
  border-top: 1px solid #bad2ed;
  width: 8px;
  top: 295px;
  left: 1096px;
  position: absolute;
}

//  3行

.node-row-3-1 {
  top: 197px;
  left: 94px;
  position: absolute;
}
.node-row-3-2 {
  top: 197px;
  left: 306px;
  position: absolute;
}
.node-row-3-3 {
  top: 197px;
  left: 518px;
  position: absolute;
}
.node-row-3-4 {
  top: 197px;
  left: 735px;
  position: absolute;
}
.node-row-3-5 {
  top: 197px;
  left: 948px;
  position: absolute;
}
// 4
.node-row-4-1 {
  top: 268px;
  left: 94px;
  position: absolute;
}
.node-row-4-2 {
  top: 268px;
  left: 306px;
  position: absolute;
}
.node-row-4-3 {
  top: 268px;
  left: 518px;
  position: absolute;
}
.node-row-4-4 {
  top: 268px;
  left: 735px;
  position: absolute;
}
.node-row-4-5 {
  top: 268px;
  left: 948px;
  position: absolute;
}

// 线
.div23 {
  top: 250px;
  left: 167px;
  position: absolute;
}
.div24 {
  top: 250px;
  left: 378px;
  position: absolute;
}
.div25 {
  top: 250px;
  left: 590px;
  position: absolute;
}
.div26 {
  top: 250px;
  left: 808px;
  position: absolute;
}
.div27 {
  top: 250px;
  left: 1023px;
  position: absolute;
}
.div28 {
  top: 130px;
  left: 141px;
  position: absolute;
}
.div29 {
  top: 130px;
  left: 350px;
  position: absolute;
}
.div30 {
  top: 130px;
  left: 561px;
  position: absolute;
}
.div31 {
  top: 130px;
  left: 780px;
  position: absolute;
}
.div32 {
  top: 130px;
  left: 983px;
  position: absolute;
}
</style>







// WEBPACK FOOTER //
// src/components/analyze/zscore.vue